// extracted by mini-css-extract-plugin
module.exports = {"topToolbar":"_18L0h","bottomToolbar":"_3DNqT"};